@if (activeSpecialOption()) {
  <app-project-banner
    [stepTitle]="activeSpecialOptionTitle() | transloco"
    [backgroundImage]="activeSpecialOptionalBackgroundImage()"
  ></app-project-banner>
  <app-content-wrapper>
    <div class="px-12">
      @for (option of specialOptions(); track option.id) {
        @if (option.id === activeSpecialOption()) {
          <ng-container *ngComponentOutlet="option.content"></ng-container>
        }
      }
    </div>
  </app-content-wrapper>
} @else if (activeStep()) {
  <app-project-banner
    [stepTitle]="activeStepTitle()"
    [backgroundImage]="activeStepBackgroundImage()"
    [showNavigation]="true"
    (navigatePrev)="onNavigatePrev()"
    (navigateNext)="onNavigateNext()"
  ></app-project-banner>
  <app-content-wrapper>
    <div class="px-12">
      <app-project-content-body></app-project-content-body>
    </div>
  </app-content-wrapper>
}
